/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServiceType } from '../../models/service-type';
import { SortDirection } from '../../models/sort-direction';
import { StationGnvConnectivityPagedList } from '../../models/station-gnv-connectivity-paged-list';

export interface GetAllConnectivityStationGnv$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;

/**
 * The station service type for filter
 */
  serviceTypes?: Array<ServiceType>;

/**
 * The station state for filter
 */
  stationHealthState?: 'GOOD' | 'BAD' | 'UNKNOWN';
}

export function getAllConnectivityStationGnv(http: HttpClient, rootUrl: string, params?: GetAllConnectivityStationGnv$Params, context?: HttpContext): Observable<StrictHttpResponse<StationGnvConnectivityPagedList>> {
  const rb = new RequestBuilder(rootUrl, getAllConnectivityStationGnv.PATH, 'get');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.query('serviceTypes', params.serviceTypes, {"style":"form","explode":false});
    rb.query('stationHealthState', params.stationHealthState, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StationGnvConnectivityPagedList>;
    })
  );
}

getAllConnectivityStationGnv.PATH = '/custom/stations-connectivity';
